export enum EntityType {
  CUSTOMER_ORDER = 'CUSTOMER_ORDER',
}

export enum ScreenType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export enum ProductOption {
  CUSTOMER_PORTAL = 'Customer Portal',
  EKO_BLEND = 'EkoBlend',
  TAR_SHAKIT = 'TarShakit',
  EKO_BAR = 'EkoBar',
}
